export enum HeroPillCategoryEnum_en {
  Products = "Products",
  Features = "Features",
  Creators = "Creators",
  Pricing = "Pricing",
}

export enum ProductsEnum_en {
  Courses = "Courses",
  Webinars = "Webinars",
  Membership = "Membership",
  DigitalProducts = "Digital products",
  TelegramCommunity = "Telegram community",
  AiAvatar="AI Avatar",
  AiAgent="AI Agent",
  AiBrain="AI Brain"
}

export enum FeaturesEnum_en {
  WebsiteBuilder = "Website builder",
  MobileApp = "Mobile app",
  ChatCommunity = "Chat community",
  MarketingTools = "Marketing tools",
  SalesInsights = "Sales insights",
  PaymentGateways = "Payment gateways",
  ThirdPartySupport = "3rd party integrations",
  MostSecurePlatform = "Secure platform",
  AiAgent = "AI Agent",
  AiBrain = "AI Brain"
}
